module.exports = __webpack_public_path__ + "img/search_s.46e8b5c5.svg";